import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, FlightOperationNotificationClient, FlightOperationNotification, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useGetFlightOperationNotificationAtVersion(id: number, versionNumber: number | undefined, role: AuthorizationRequestType) {
  return useQuery<FlightOperationNotification, ProblemDetails>({
    queryKey: [queryKeys.FlightOperationNotification.GetAtVersion, { id, versionNumber }],
    queryFn: () => flightOperationNotificationClient.getAtVersion(id, versionNumber ?? 0, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: versionNumber !== undefined,
  });
}

export default useGetFlightOperationNotificationAtVersion;
